import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../Context/CartContext";
import "./Navbar.css";
import {
  FiSearch,
  FiUser,
  FiShoppingBag,
  FiMenu,
  FiX,
} from "react-icons/fi";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { cartItems } = useCart();

const totalItems = cartItems.reduce(
  (total, item) => total + item.quantity,
  0
);

  return (
    <>
      <nav className="navbar-section">
       <div className="nav-container">

          <div className="mobile-menu">
            <FiMenu onClick={() => setMenuOpen(true)} />
          </div>

          <div className="nav-left">
            <a href="/shop">SHOP</a>
            <a href="/">COLLECTIONS</a>
            <a href="/about">ABOUT</a>
            <a href="/">SCENTS</a>
          </div>

          <div className="nav-logo">
            <a href="/">SAH?</a>
          </div>

          <div className="nav-right">
            <FiSearch className="nav-icon" />
            <FiUser className="nav-icon" />
           <Link to="/cart" className="cart-icon-wrapper">
  <FiShoppingBag className="nav-icon" />

  {totalItems > 0 && (
    <span className="cart-badge">
      {totalItems}
    </span>
  )}
</Link>
          </div>

        </div>
      </nav>

      <div className={`sidebar ${menuOpen ? "show" : ""}`}>
        <div className="sidebar-top">
          <FiX
            className="close-icon"
            onClick={() => setMenuOpen(false)}
          />
        </div>

        <a href="/shop" onClick={() => setMenuOpen(false)}>
          SHOP
        </a>

        <a href="/" onClick={() => setMenuOpen(false)}>
          COLLECTIONS
        </a>

        <a href="/about" onClick={() => setMenuOpen(false)}>
          ABOUT
        </a>

        <a href="/" onClick={() => setMenuOpen(false)}>
          FRAGRANCES
        </a>
      </div>

      {menuOpen && (
        <div
          className="overlay"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
    </>
  );
}

export default Navbar;